const { safeInternalPath } = require('../../router/safeInternalPath');
const { canonicalPlayerLink } = require('./playerRoutes');
const isSubscriptionStream = require('./isSubscriptionStream');
const secureStream = require('./secureStream');
const streamQuality = require('../../routes/MetaDetails/StreamsList/streamQuality');
const streamLanguage = require('../../routes/MetaDetails/StreamsList/streamLanguage');

// Manual choices only. No retries, failed-source bookkeeping or automatic navigation.
let cached = null;
const MAX_AGE_MS = 30 * 60 * 1000;

const manualSourcesGroup = (type, metaId, videoId) => [type, metaId, videoId].every((value) => typeof value === 'string' && value)
    ? JSON.stringify([type, metaId, videoId]) : null;

const sourceIdentity = (stream) => {
    const url = secureStream(stream)?.url;
    if (typeof url === 'string') return JSON.stringify(['url', url]);
    if (typeof stream?.infoHash === 'string') return JSON.stringify(['torrent', stream.infoHash, stream.fileIdx ?? null]);
    return null;
};

const createManualSources = (results) => {
    const seen = new Set();
    return results.filter((item) => item.httpState !== 'failed' && !isSubscriptionStream(item.stream)).slice().sort((a, b) =>
        (a.playbackVerified ? 0 : a.state === 'active' ? 1 : 2) - (b.playbackVerified ? 0 : b.state === 'active' ? 1 : 2))
        .flatMap(({ stream, state, playbackVerified }) => {
            const link = stream?.deepLinks?.player;
            const path = typeof link === 'string' ? safeInternalPath(link.startsWith('#') ? link.slice(1) : link) : null;
            if (!path?.startsWith('/player/') || seen.has(path) || seen.size >= 100) return [];
            seen.add(path);
            return [{ path: canonicalPlayerLink(path), launchLink: link, identity: sourceIdentity(stream), quality: streamQuality(stream), language: streamLanguage(stream),
                verification: playbackVerified ? 'verified' : state === 'active' ? 'responsive' : 'unknown' }];
        });
};

const registerManualSources = (group, results) => {
    if (group) cached = { group, items: createManualSources(results), createdAt: Date.now() };
};
const getManualSources = (group) => cached?.group === group && Date.now() - cached.createdAt < MAX_AGE_MS
    ? cached.items.map((item) => ({ ...item })) : [];

module.exports = { createManualSources, registerManualSources, getManualSources, sourceIdentity, manualSourcesGroup };
